var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-footer"},[_c('AwardLogos',{attrs:{"name":_vm.$store.state.awardsName,"classes":'award-logos--reset'}}),_c('SocialIcons',{attrs:{"type":"story","staticPosition":true}}),_c('Copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }